import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import { styled } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import '../Styles/App/HomeMB2.css'
import RegisterMb from './Login/RegisterMb'
import {
  gtmOpenRegisterUNL
} from '../Constants/GoogleTagManager/gtmConstants'
import Section2HomeWeb from './SectionsHomeMB2/Section2/Section2Web'
import Section2HomeMobile from './SectionsHomeMB2/Section2/Section2Mobile'
import Section3HomeWeb from './SectionsHomeMB2/Section3/Section3Web'
import Section4HomeWeb from './SectionsHomeMB2/Section4/Section4Web'
import Section5HomeWeb from './SectionsHomeMB2/Section5/Section5Web'
import Section5HomeMobile from './SectionsHomeMB2/Section5/Section5Mobile'
import Section6HomeWeb from './SectionsHomeMB2/Section6/Section6Web'
import SectionHomeWeb from './SectionsHomeMB2/Section1/SectionHomeWeb'
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  appBarTransparent: {
    display: 'block',
    // position: 'fixed',
    // color: '#cbb878',
    // bottom: '30px',
    // fontSize: '120px !important',
    // backgroundColor: '#0000001a !important',
    transition: 'all .9s ease-in-out !important',
    // backdropFilter: 'blur(3px)',
    opacity: 1,
  },
  appBarSolid: {
    // display: 'none',
    // backgroundColor: '#183076 !important',
    transition: 'all .9s ease-in-out !important',
    opacity: 0,
  },
})

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#cfb76d',
    color: '#000',
    textTransform: 'uppercase',
    fontWeight: '600',
    // fontSize: window.screen.width <= 600 ? 9 : null,
    border: 0,
    paddingTop: 5,
    paddingBottom: 7,
    // borderRadius: '20px',
    textAlign: 'center',
  },
  [`&.${tableCellClasses.body}`]: {
    color: '#545454',
    // padding: window.screen.width <= 600 ? 13 : null,
    // fontSize: window.screen.width <= 600 ? 8 : null,
    border: 0,
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: 'center',
    fontWeight: 'bold',
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    // backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}))

const HomeN = (props) => {
  const [navBackground, setNavBackground] = useState('appBarTransparent')
  const navRef = React.useRef()
  navRef.current = navBackground
  const classes = useStyles()
  const navigate = useNavigate()
  const userLogin = useSelector((state) => state.userLogin)
  const { loading, error, userInfo } = userLogin

  const [openSingUp, setOpenSingUp] = useState(false)
  const handleOpenSingUp = () => {
    gtmOpenRegisterUNL()
    setOpenSingUp(!openSingUp)
  }

  const handleCloseSingUp = () => {
    setOpenSingUp(false)
  }
  const handleChange = (event, newValue) => {
    console.log(newValue)
    // setValue(newValue)
  }
  function createData(name, calories, fat) {
    return { name, calories, fat }
  }
  const rows = [
    createData('-', '$ 10,000.00 MXN', '70%'),
    createData('$ 10,001.00 MXN', '$ 20,000.00 MXN', '75%'),
    createData('$ 20,001.00 MXN', '$ 35,000.00 MXN', '80%'),
    createData('$ 35,001.00 MXN', '$ 100,000.00 MXN', '82%'),
    createData('$ 100,001.00 MXN', '+', '85%'),
  ]
  function createDataa(name, calories) {
    return { name, calories }
  }
  const rowsMovil = [
    createDataa('-', '70%'),
    createDataa('$ 10,001.00', '75%'),
    createDataa('$ 20,001.00', '80%'),
    createDataa('$ 35,001.00', '82%'),
    createDataa('$ 100,001.00', '85%'),
  ]
  const columns = [
    {
      id: 'CostoMinimo',
      label: 'Costo Mínimo',
      radius: '30px 0px 0px 30px',
    },
    {
      id: 'CostoMaximo',
      label: 'Costo Máximo',
    },
    {
      id: 'GananciaFinal',
      label: 'Ganancia Final',
      radius: '0px 30px 30px 0px',
    },
  ]
  const columnsMovil = [
    {
      id: 'Costo',
      label: 'Costo',
      // radius: '30px 0px 0px 30px',
    },
    {
      id: 'Ganancia',
      label: 'Ganancia',
      // radius: '0px 30px 30px 0px',
    },
  ]
  const goShopify = () => {
    window.open('https://founditpreloved.com/', '_blank')
  }
  const goLuxury = () => {
    window.open(
      'https://founditpreloved.com/collections/disenadores#tab-luxury',
      '_blank'
    )
  }

  const goShopifyCompra = () => {
    window.open('https://founditpreloved.com/', '_blank')
  }
  const goAuthenticationProcess = () => {
    window.open(
      'https://founditpreloved.com/pages/proceso-de-autentificacion',
      '_blank'
    )
  }

  useEffect(() => {
    const handScroll = () => {
      var data = 0
      if (window.screen.width <= 600) {
        data = 4900
      } else {
        data = 3800
      }
      const show = window.scrollY > data
      if (show) {
        setNavBackground('appBarSolid')
      } else {
        setNavBackground('appBarTransparent')
      }
    }
    document.addEventListener('scroll', handScroll)
    return () => {
      document.removeEventListener('scroll', handScroll)
    }
  }, [])
  return (
    <div className="bg-white-color">
      <SectionHomeWeb props={props} />
    </div>
  )
}

export default HomeN
